import { Injectable, inject } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { TenantContextService } from "../services/tenant-context.service";

/**
 * Injects the active tenant's `X-Org-Id` header on every outbound request
 * so backend TenantScopedRepository filters queries correctly.
 *
 * The `/api/me/memberships` endpoint itself is excluded — it needs to
 * run before we know which tenant is active, so adding X-Org-Id there
 * would dead-lock the resolve.
 */
@Injectable()
export class TenantHeaderInterceptor implements HttpInterceptor {
  private readonly ctx = inject(TenantContextService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.url.includes("/api/me/memberships")) {
      return next.handle(req);
    }

    const orgId = this.ctx.organizationId();
    if (orgId == null) return next.handle(req);

    const cloned = req.clone({
      setHeaders: { "X-Org-Id": String(orgId) },
    });
    return next.handle(cloned);
  }
}
